/**
 * NewQiblaCard.jsx
 * ----------------
 * Thin re-export that preserves the historic import path used by
 *   src/App.js
 * The real implementation now lives under
 *   src/components/qibla/
 * as a set of small, single-purpose components composed by
 *   QiblaContainer.jsx
 *
 * Keep this file as a compatibility shim — do NOT add logic here.
 */
import QiblaContainer from './qibla/QiblaContainer';

export default QiblaContainer;
